module.exports = __webpack_public_path__ + "static/media/020.6124c8c1.jpg";